export default "/images/info-square.svg?6163c2b47b071d3e1425d68d4214beb8";